import React from 'react';

const Contact = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">Contact</h1>
      
      <div className="space-y-6 text-gray-800">
        {/* Add your contact information or form here */}
        <p className="text-lg leading-relaxed">
          Get in touch with me through the following channels.
        </p>
      </div>
    </div>
  );
};

export default Contact; 